module.exports = __webpack_public_path__ + "static/media/Bell.abdb15b0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/Pomodoro/sounds/Bell.wav
// module id = 94
// module chunks = 0